export default "__VITE_ASSET__Df6bC2fe__"